<template>

    <div class="miniature">

        <!--        SORT_DURING_SCAN-->
        <div class="image sort-during-scan" v-if="type === ENUM.HELP.FEATURES.SORT_DURING_SCAN"></div>

        <!--        DELETED_MAILS-->
        <div class="image deleted-mails" v-if="type === ENUM.HELP.FEATURES.DELETED_MAILS">
            <span>{{ $t('help_new_mails_received') }}</span>
        </div>

        <!--        NEW_SENDERS-->
        <div class="image new-senders" v-if="type === ENUM.HELP.FEATURES.NEW_SENDERS">
            <span><div class="round-blue"></div> {{ $t('help_new_mails_new') }}</span>
        </div>

        <!--        SORT_LATER-->
        <div class="image sort-later" v-if="type === ENUM.HELP.FEATURES.SORT_LATER"></div>

        <!--        REVERSE_ACTION-->
        <div class="image reverse-action" v-if="type === ENUM.HELP.FEATURES.REVERSE_ACTION">
            <span><img src="/img/newsletters-v2/clock-blue.svg"> {{$t('reverse_action')}}</span>
        </div>

        <!--        ACTIONS-->
        <div class="image actions" v-if="type === ENUM.HELP.FEATURES.ACTIONS"></div>


    </div>

</template>

<script>


export default {

    name: 'help-miniature',

    components: {},

    props: {
        type: {
            type: String,
            default: ''
        }
    },

    computed: {},

    data() {
        return {}
    },

    methods: {}


}

</script>

<style lang="scss" scoped>

.miniature {
    width: 100%;
    display: flex;
    position: relative;

    .image {
        width: 100%;
        object-fit: contain;
        background-repeat: no-repeat;
        background-position: center;
        background-size: contain;
        height: 120px;
        border-radius: 16px;
        @media screen and (min-width: $above-tablet-length) {
            height: 140px;
        }
    }

    .sort-during-scan {
        background-image: url("/img/help/sort-scan/sort-scan-miniature.svg");
    }

    .deleted-mails {
        background-image: url("/img/help/deleted-mails/new-mail-miniature.svg");

        span {
            position: absolute;
            padding: 2px 4px;
            border-radius: 14px;
            background-color: $chardon;
            color: $sunset;
            font-size: 9px;
            font-weight: 500;
            top: 40%;
            left: 22%;
        }
    }

    .new-senders {
        background-image: url("/img/help/new-sender/new-sender-miniature.svg");

        span {
            display: flex;
            flex-direction: row;
            align-items: center;
            background-color: $white;
            padding: 3px 7px;
            position: absolute;
            border-radius: 16px;
            top: 35%;
            left: 40%;
            font-size: 12px;
            font-weight: 500;


            .round-blue {
                width: 8px;
                height: 8px;
                border-radius: 8px;
                background-color: $aquamarine;
                margin-right: 7px;
            }
        }
    }

    .sort-later {
        background-image: url("/img/help/sort-later/sort-later-miniature.svg");
    }

    .reverse-action {
        background-image: url("/img/help/history/history-miniature.svg");

        span {
            padding: 4px 8px;
            border-radius: 18px;
            background-color: $white;
            display: flex;
            flex-direction: row;
            align-items: center;
            font-size: 9px;
            font-weight: 600;
            position: absolute;
            top: 37%;
            left: 40%;
            img {
                width: 12px;
                object-fit: contain;
                margin-right: 5px;
            }
        }
    }

    .actions {
        background-image: url("/img/help/actions/actions-miniature.svg");
    }
}


</style>
